import { render, staticRenderFns } from "./AirRank.vue?vue&type=template&id=bcb9913c&scoped=true&"
import script from "./AirRank.vue?vue&type=script&lang=js&"
export * from "./AirRank.vue?vue&type=script&lang=js&"
import style0 from "./AirRank.vue?vue&type=style&index=0&id=bcb9913c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb9913c",
  null
  
)

export default component.exports